'use client';

import { Flex, Stack, Text } from '@mantine/core';

import styles from './Footer.module.css';

const FooterLinks = () => {
  return (
    <>
      <Text
        component="a"
        href="/"
        fw={600}
        size="sm"
      >
        {' '}
        Sway{' '}
      </Text>
      <Text
        component="a"
        href="/faq"
        size="sm"
      >
        FAQ
      </Text>
      <Text
        component="a"
        href="/terms"
        size="sm"
      >
        Terms of Service
      </Text>
      <Text
        component="a"
        href="/privacy"
        size="sm"
      >
        Privacy Policy
      </Text>
      <Text
        component="a"
        href="/community"
        size="sm"
      >
        Community Guidelines
      </Text>
      <Text
        c="dimmed"
        size="sm"
      >
        2025
      </Text>
    </>
  );
};

const Footer = ({ isDesktopView = false }: { isDesktopView?: boolean }) => {
  return isDesktopView ? (
    <Flex
      className={styles.footer}
      gap="sm"
    >
      <FooterLinks />
    </Flex>
  ) : (
    <Stack
      className={styles.mobileFooter}
      gap="sm"
      ta="right"
    >
      <FooterLinks />
    </Stack>
  );
};

export { Footer };
